export const MAP_SETTINGS_VISIBILITY_SHOW_PROXIMITY = 'MAP_SETTINGS_VISIBILITY_SHOW_PROXIMITY';
export const MAP_SETTINGS_VISIBILITY_HIDE_PROXIMITY = 'MAP_SETTINGS_VISIBILITY_HIDE_PROXIMITY';

export const MAP_SETTINGS_VISIBILITY_SHOW_HEATMAP = 'MAP_SETTINGS_VISIBILITY_SHOW_HEATMAP';
export const MAP_SETTINGS_VISIBILITY_HIDE_HEATMAP = 'MAP_SETTINGS_VISIBILITY_HIDE_HEATMAP';
